// @ts-nocheck

import { createContext, useContext } from 'react';

type BoomHomeContextProps = {
  nbWonSteps: number;
  currentStepId: string;
};

export const BoomHomeContext = createContext<BoomHomeContextProps>({});

export const useBoomHomeContext = () => useContext(BoomHomeContext);
